<template>
   <vueper-slides class="opportunita-carousel no-shadow" autoplay :arrows="false" fade fixed-height="400px">
      <vueper-slide v-for="opportunita in $teras.opportunita_home" :key="opportunita.id">
         <template #content>
            <opportunita-home-listitem :opportunita="opportunita" />
         </template>
      </vueper-slide>
   </vueper-slides>
</template>
<script>
import { VueperSlides, VueperSlide } from "vueperslides"
import "vueperslides/dist/vueperslides.css"
import { defineAsyncComponent } from "vue"
export default {
   components: {
      VueperSlides, VueperSlide,
      OpportunitaHomeListitem: defineAsyncComponent(() => import("@/components/Teras/Opportunita-home-listitem.vue")),
   },
}
</script>